import React from 'react'
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel';

const CmnStoneSearch = (props) => {
    const { rowKey, itemParam, qualityParam, shapeParam, widthParam, lengthParam, heightParam,
        formObject } = props;

    return (
        <>
            <span className="uiLblInLine">
                <FormLabel formObject={formObject} rowKey={rowKey || ""} action={{ paramName: itemParam || "item" }} value="Stone" />
            </span>
            <FormInput formObject={formObject} rowKey={rowKey || ""} className="uiInput" style={{width:'130px'}}
                placeholder="Item Name..."
                action={{ InputType: "ac", paramName: itemParam || "item", acMethod: "Item", acDepCtrl: { dtid: '%dataList.valLDT', level: '%dataList.level' } ,
                actionId: "refresh", actionParam: {changeitem:1} }} />
            <FormInput formObject={formObject} rowKey={rowKey || ""} className="uiInput" style={{width:'70px'}}
                placeholder="Quality..."
                action={{ InputType: "ac", paramName: qualityParam || "attrQuality", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' },
                actionId: "refresh", actionParam: {changeitem:1} }} />
            <FormInput formObject={formObject} rowKey={rowKey || ""} className="uiInput" style={{width:'70px'}}
                placeholder="Shape..."
                action={{ InputType: "ac", paramName: shapeParam || "attrShape", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' },
                actionId: "refresh", actionParam: {changeitem:1} }} />
            <span className="uiLblInLine">
                <FormLabel formObject={formObject} rowKey={rowKey || ""} action={{ paramName: "attrWidth" }} value="Wd" />
            </span>
            <FormInput formObject={formObject} rowKey={rowKey || ""} className="uiInput" style={{width:'40px'}}
                action={{ InputType: "input", paramName: widthParam || "attrWidth", actionId: "refresh", actionParam: {changeitem:1} }} />
            <span className="uiLblInLine">
                <FormLabel formObject={formObject} rowKey={rowKey || ""} action={{ paramName: "attrLength" }} value="Ln" />
            </span>
            <FormInput formObject={formObject} rowKey={rowKey || ""} className="uiInput" style={{width:'40px'}}
                action={{ InputType: "input", paramName: lengthParam || "attrLength", actionId: "refresh", actionParam: {changeitem:1} }} />
            <span className="uiLblInLine">
                <FormLabel formObject={formObject} rowKey={rowKey || ""} action={{ paramName: "attrHeight" }} value="Ht" />
            </span>
            <FormInput formObject={formObject} rowKey={rowKey || ""} className="uiInput" style={{width:'40px'}}
                action={{ InputType: "input", paramName: heightParam || "attrHeight", actionId: "refresh", actionParam: {changeitem:1} }} />
        </>
    )
}

export default CmnStoneSearch;
